import {loadingOverlayActions, notifsActions} from "../index";
import {createMessageRequestException, listaIndividui} from "../../fanctionUtility";
import new_axios_instance from '../../axios_instance';


import {dayJS} from "../../applicationConf";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {pianificazioniActions} from "../../slices/pianificazioniSlice";

const regex = /.*(SCR$)|(FSE$)/g;


/******************************************* Inserimento nuova pianificazione *****************************************************/
export const addPianificazione = createAsyncThunk(
    'pianificazioni/inserisci',
    async ({pianificazione, navigate, isEditing}, thunkApi) => {
        thunkApi.dispatch(loadingOverlayActions.showLoadingOverlay());
        let url = '/v1/pianificazione/inserisci'
        if (isEditing) {
            url += '?edit=true';
        }
        return await new_axios_instance.post(url, pianificazione)
            .then(response => {
                const docentiGiaPianificati = response.data?.docentiGiaPianificati || [];
                if (!isEditing && docentiGiaPianificati.length > 0) {
                    // segnalazione non bloccante: la pianificazione è già stata salvata
                    const nomi = listaIndividui(thunkApi.getState().docenti.docenti);
                    const righe = docentiGiaPianificati.map(id => `- ${id === pianificazione.idAnagraficaDocente ? 'docente' : 'co-docente'} ${nomi.find(d => d.value === id)?.displayValue || id}`);
                    thunkApi.dispatch(notifsActions.notifWarning(['Operazione avvenuta con successo.', 'Attenzione: già pianificati in un altro corso nello stesso orario:', ...righe, 'Contattare i docenti indicati.'].join('\n'), 30000));
                } else {
                    thunkApi.dispatch(notifsActions.notifSuccess('Operazione avvenuta con successo'));
                }
                thunkApi.dispatch(loadingOverlayActions.hideLoadingOverlay());
                window.history.back()
            })
            .catch(error => {
                const message = createMessageRequestException(error);
                thunkApi.dispatch(notifsActions.notifError(message));
                thunkApi.dispatch(loadingOverlayActions.hideLoadingOverlay());
                thunkApi.dispatch(pianificazioniActions.addPianificazioneFail(message));
            })
    }
);

/******************************************* Inserimento nuova pianificazione *****************************************************/

/******************************************* Recupero pianificazione per modifica *****************************************************/

export const getPianificazioneForUpdate = createAsyncThunk(
    'pianificazioni/inserisci',
    async ({id, data, idPianificazione}, thunkApi) => {
        await new_axios_instance.get(`/v1/pianificazione/recupera/${idPianificazione}`)
            .then(response =>
                thunkApi.dispatch(pianificazioniActions.setPianificazioneToUpdate(response.data))
            )
            .catch(error =>
                thunkApi.dispatch(notifsActions.notifError(createMessageRequestException(error))))
    }
);

/******************************************* Recupero pianificazione per modifica *****************************************************/

/******************************************* Esclusione della pianificazione pulsante cancella nel calendario *****************************************************/

export const pianificazioneEsclusioneStart = createAsyncThunk(
    'pianificazioni/esclusione',
    async ({param: pianificazioneEsclusione, navigate, pathname}, thunkAPI) => {
        thunkAPI.dispatch(loadingOverlayActions.showLoadingOverlay());
        await new_axios_instance.post(`/v1/pianificazione/esclusione/inserisci`, pianificazioneEsclusione)
            .then(() => {
                thunkAPI.dispatch(loadingOverlayActions.hideLoadingOverlay());
                thunkAPI.dispatch(notifsActions.notifSuccess('Operazione per il giorno, ' + dayJS(pianificazioneEsclusione.data).format('DD-MM-YYYY') + ' avvenuta con successo'));
                thunkAPI.dispatch(pianificazioniActions.pianificazioniInit());
                navigate(`/corso/${pianificazioneEsclusione.idCorso}/${!regex.test(pathname) ? 'calendarioFSE' : 'calendarioSCR'}`);
            }).catch(error => {
                const message = createMessageRequestException(error);

                thunkAPI.dispatch(pianificazioniActions.pianificazioniEsclusioneFail(message));
                thunkAPI.dispatch(notifsActions.notifError(message));

                thunkAPI.dispatch(loadingOverlayActions.hideLoadingOverlay());
            });
    });

/******************************************* Esclusione della pianificazione pulsante cancella nel calendario *****************************************************/

/******************************************* Verifica conflitti durante modifica della pianificazione nel calendario **********************************************/

export const pianificazioniConflitti = createAsyncThunk(
    'pianificazioni/conflitti',
    async (pianificazione, thunkAPI) => {
        thunkAPI.dispatch(loadingOverlayActions.showLoadingOverlay());
        await new_axios_instance.post(`/v1/pianificazione/ricerca/conflitto`, pianificazione)
            .then(response => {
                thunkAPI.dispatch(pianificazioniActions.pianificazioniConflittiSuccess(response.data));
                thunkAPI.dispatch(loadingOverlayActions.hideLoadingOverlay());
            })
            .catch(error => {
                thunkAPI.dispatch(notifsActions.notifError(createMessageRequestException(error)));
                thunkAPI.dispatch(loadingOverlayActions.hideLoadingOverlay());

                window.scrollTo({top: 0, behavior: "smooth"});
                document.getElementsByTagName('main')[0].scrollTo({top: 0, behavior: "smooth"});
            })
    });

/******************************************* Verifica conflitti durante modifica della pianificazione nel calendario **********************************************/

export const getUltimaPianificazione = async (idCorso) => {
    let ultimaPianificazione = null;

    try {
        ultimaPianificazione = (await new_axios_instance.get(`/v1/pianificazione/corso/${idCorso}/ultima`)).data
    } catch (_) {}

    return ultimaPianificazione;
}


export const getSeriePerRangeDiDate = async (idCorso, startDate, endDate) => {
    let serie = [];

    try {
        serie = (await new_axios_instance.get(`/v1/pianificazione/recupera/serie/${idCorso}/${startDate}/${endDate}`)).data
    } catch (_) {}

    return serie;
}